import Axios from "axios";
import React from "react";
import { useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import toast from "react-hot-toast";
import { baseUrl } from "../../../services/config";

/**
 * FCM HTTP v1 API Migration Notes:
 *
 * REQUIRED SETUP:
 * 1. Get your Firebase Project ID from Firebase Console (Project Settings)
 * 2. Create a backend endpoint at `/admin/fcm-access-token` that:
 *    - Uses Firebase Admin SDK to generate OAuth 2.0 access tokens
 *    - Returns the token in format: { accessToken: "your-token" }
 *
 * BACKEND IMPLEMENTATION EXAMPLE (Node.js):
 * ```
 * const admin = require('firebase-admin');
 * const serviceAccount = require('./path-to-service-account-key.json');
 *
 * admin.initializeApp({
 *   credential: admin.credential.cert(serviceAccount)
 * });
 *
 * app.get('/admin/fcm-access-token', async (req, res) => {
 *   const accessToken = await admin.credential.applicationDefault().getAccessToken();
 *   res.json({ accessToken: accessToken.access_token });
 * });
 * ```
 *
 * KEY CHANGES FROM LEGACY API:
 * - Endpoint: fcm/send → v1/projects/{projectId}/messages:send
 * - Auth: Server key → OAuth 2.0 Bearer token
 * - Payload: { notification, to } → { message: { token, notification } }
 */

function SendNotification({ show, hideModal, listokens, onCheckboxChange, onSendNotification }) {
  console.log("🚀 ~ SendNotification ~ listokens:", listokens);

  const authToken = localStorage.getItem("userToken");

  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [body, setbody] = useState("");
  const [imageUrlshow, setImageUrlshow] = useState("");
  const [imageLoading, setimageLoading] = useState(false);

  // Checkbox states for notification options
  const [allDevices, setAllDevices] = useState(false);
  const [joinClub, setJoinClub] = useState(false);
  const [foldableJoinClub, setFoldableJoinClub] = useState(false);

  const sendNotification = async () => {
    if (title === "" || body === "") {
      toast.error("Please enter a title and body");
      return;
    }

    setLoading(true);
    
    try {
      const formData = new FormData();
      formData.append('title', title);
      formData.append('body', body);
      if (imageUrlshow) {
        formData.append('image', imageUrlshow);
      }
      formData.append('tokens', JSON.stringify(listokens));
      
      // Add checkbox values to formData
      formData.append('all', allDevices ? '1' : '0');
      formData.append('join_club', joinClub ? '1' : '0');
      formData.append('foldable_join_club', foldableJoinClub ? '1' : '0');

      // Call the parent function to send notification
      if (onSendNotification) {
        await onSendNotification(formData);
      }

      toast.success("Notification sent successfully!");
      setTitle("");
      setbody("");
      setImageUrlshow("");
      setAllDevices(false);
      setJoinClub(false);
      setFoldableJoinClub(false);
      hideModal();
    } catch (error) {
      toast.error("Failed to send notification");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const onImageChange = (img) => {
    setimageLoading(true);

    const fdata = new FormData();
    fdata.append("image", img);
    Axios.post(`${baseUrl}/admin/notification-image`, fdata, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((res) => {
        setImageUrlshow(res.data);
        setimageLoading(false);
      })
      .catch((err) => {
        setimageLoading(false);
        toast.error("Failed to upload image");
        console.log(err);
      });
  };

  return (
    <Modal show={show}>
      <Modal.Header>
        <Modal.Title>Send Notification To All</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <input
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Title of Notification"
          className="form-control m-2"
        />

        <textarea
          rows={2}
          value={body}
          onChange={(e) => setbody(e.target.value)}
          placeholder="Body of Notification"
          className="form-control m-2"
        />

        {imageLoading ? (
          <Spinner animation="border" />
        ) : (
          <input
            type={"file"}
            onChange={(e) =>
              e.target.files &&
              e.target.files[0] &&
              onImageChange(e.target.files[0])
            }
            className="form-control m-2"
          />
        )}

        {imageUrlshow ? (
          <div
            style={{
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "flex-end",
            }}
          >
            <span
              onClick={() => setImageUrlshow("")}
              className="btn btn-danger m-2"
            >
              Remove
            </span>
          </div>
        ) : null}
        {imageUrlshow ? (
          <img
            loading={"lazy"}
            style={{
              height: "auto",
              width: "100%",
              objectFit: "contain",
            }}
            src={imageUrlshow}
            alt="Notification preview"
          />
        ) : null}

        <div className="m-3">
          <h6>Notification Options:</h6>
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="allDevices"
              checked={allDevices}
              onChange={(e) => {
                const isChecked = e.target.checked;
                setAllDevices(isChecked);
                // When All Devices is checked, uncheck and disable other options
                if (isChecked) {
                  setJoinClub(false);
                  setFoldableJoinClub(false);
                  if (onCheckboxChange) {
                    onCheckboxChange("join_club", "0");
                    onCheckboxChange("foldable_join_club", "0");
                  }
                }
                if (onCheckboxChange) {
                  onCheckboxChange("all", isChecked ? "1" : "0");
                }
              }}
            />
            <label className="form-check-label" htmlFor="allDevices">
              All Devices
            </label>
          </div>
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="joinClub"
              checked={joinClub}
              disabled={allDevices}
              onChange={(e) => {
                setJoinClub(e.target.checked);
                if (onCheckboxChange) {
                  onCheckboxChange("join_club", e.target.checked ? "1" : "0");
                }
              }}
            />
            <label className="form-check-label" htmlFor="joinClub">
              Join Club
            </label>
          </div>
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="foldableJoinClub"
              checked={foldableJoinClub}
              disabled={allDevices}
              onChange={(e) => {
                setFoldableJoinClub(e.target.checked);
                if (onCheckboxChange) {
                  onCheckboxChange(
                    "foldable_join_club",
                    e.target.checked ? "1" : "0"
                  );
                }
              }}
            />
            <label className="form-check-label" htmlFor="foldableJoinClub">
              Foldable Join Club
            </label>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {loading ? (
          <Spinner animation="border" />
        ) : (
          <>
            <button
              disabled={imageLoading}
              onClick={sendNotification}
              className="btn btn-primary"
            >
              Send
            </button>
            <button onClick={hideModal} className="btn btn-danger">
              Close
            </button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
}

export default SendNotification;